function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// /*------------------------------------------------------------------
// Import Modules
// ------------------------------------------------------------------*/

import { ajax, serialize, nodeArray, offset } from 'meteora';

// /*------------------------------------------------------------------
// Form Class
// ------------------------------------------------------------------*/
var Form = /*#__PURE__*/function () {
  function Form(form) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Form);
    // The form element
    this.form = form;
    // This will be used for form validation
    this.validation = {};

    // user settings
    this.settings = {
      validate: true,
      recaptcha: false,
      messages: true,
      success: function success(response) {
        console.log('You have not set up a success callback. Pass your success callback into the creation of the new Form(formElement, success(Form, response)). You are currently recieving this as your response: ', response);
      }
    };

    // Simple object assign
    for (var key in this.settings) {
      if (options[key] !== undefined) this.settings[key] = options[key];
    }

    // Grab some initial details
    this.init(this.form);
    // Set up the form
    this.setup(this.form);
  }
  _createClass(Form, [{
    key: "init",
    value: function init(form) {
      // If we are using google recaptcha
      if (this.settings.recaptcha) {
        // Check to see if there is a recaptcha element
        this.recaptcha = {};
        this.recaptcha["default"] = this.form.querySelector('.g-recaptcha') || false;
        this.recaptcha.settings = {};
        this.recaptcha.timeout = null;
        this.recaptcha.ready = false;

        // Grab all the recaptcha settings
        for (var key in this.recaptcha["default"].dataset) {
          this.recaptcha.settings[key] = this.recaptcha["default"].dataset[key];
        }
      }

      // If we want validation
      if (this.settings.validate) {
        // Here we declear our tests.
        this.test = {
          text: function text(field) {
            return field.input.value.length >= 1 && field.input.required || !field.input.required;
          },
          email: function email(field) {
            var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
            var valid = true;
            if (field.input.required && field.input.value.length === 0) {
              valid = false;
            } else if (field.input.value.length >= 1) {
              valid = pattern.test(field.input.value);
            }
            return valid;
          },
          option: function option(field) {
            var valid = true;
            if (field.input.required && field.input.checked === false) valid = false;
            return valid;
          },
          select: function select(field) {
            var valid = false;
            if (field.input.required) {
              var options = nodeArray(field.input.querySelectorAll('option'));
              for (var i = 0; i < options.length; i++) {
                if (options[i].selected && options[i].value !== '') {
                  valid = true;
                  break;
                }
              }
            } else {
              valid = true;
            }
            return valid;
          }
        };
      }
    }
  }, {
    key: "setup",
    value: function setup(form) {
      var _this = this;
      // The form element
      this.form = form;

      // Spam protection
      if (this.settings.recaptcha) this.protect();

      // If we want validation
      if (this.settings.validate) {
        // Any array to hold our required fields
        this.validation.fields = [];

        // Loop the required validation fields
        nodeArray(this.form.querySelectorAll('[required], [type="email"]')).forEach(function (input) {
          // Create a new p tag to display validation errors
          _this.validation.message = document.createElement('p');
          // Give this element a class so we can style it`
          _this.validation.message.classList.add('js-form--message');

          // Insert it before the field
          input.parentNode.appendChild(_this.validation.message);
          var field = {
            input: input,
            message: _this.validation.message,
            valid: false
          };

          // Push an object that holds the message and field
          _this.validation.fields.push(field);
          input.addEventListener('blur', function () {
            return _this.validate([field]);
          });
          input.addEventListener('change', function () {
            return _this.validate([field]);
          });
        });
      }
      this.form.querySelector('[type="submit"]').addEventListener('click', function (e) {
        // e.preventDefault();
        _this.submit(e);
      });
    }
  }, {
    key: "protect",
    value: function protect() {
      var _this2 = this;
      this.recaptcha.timeout = function () {
        if (window.grecaptcha == undefined || window.grecaptcha == null) {
          setTimeout(function () {
            return _this2.recaptcha.timeout();
          }, 500);
        } else if (_this2.recaptcha["default"]) {
          window.grecaptcha.ready(function () {
            return _this2.recaptcha.ready = true;
          });
        }
      };
      this.recaptcha.timeout();
      if (this.recaptcha.ready) {
        this.recaptcha["default"] = this.form.querySelector('.g-recaptcha') || false;
        this.recaptcha.parent = this.recaptcha["default"].parentNode || false;

        // Create a new div to handle our recaptcha
        this.recaptcha["new"] = document.createElement('div');
        // Add the data to the new element
        for (var key in this.recaptcha.settings) this.recaptcha["new"].setAttribute("data-".concat(key), this.recaptcha.settings[key]);

        // Append the new recaptcha element
        this.recaptcha.parent.insertBefore(this.recaptcha["new"], this.recaptcha["default"]);
        // Remove the old recaptcha element
        this.recaptcha.parent.removeChild(this.recaptcha["default"]);
        // Render the new one
        this.recaptcha["default"] = this.recaptcha["new"];

        // Reload the recaptcha
        window.grecaptcha.render(this.recaptcha["new"]);
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      var _this3 = this;
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.validation.fields;
      // Start by saying the form is valid
      this.validation.valid = true;

      // Test all the required inputs
      fields.forEach(function (field) {
        if (field.input.tagName == 'INPUT') {
          switch (field.input.type) {
            case 'checkbox':
              field.valid = _this3.test.option(field);
              break;
            case 'radio':
              field.valid = _this3.test.option(field);
              break;
            case 'email':
              field.valid = _this3.test.email(field);
              break;
            default:
              field.valid = _this3.test.text(field);
          }
        } else if (field.input.tagName == 'SELECT') {
          field.valid = _this3.test.select(field);
        } else if (field.input.tagName == 'TEXTAREA') {
          field.valid = _this3.test.text(field);
        } else {
          console.warn('This JavaScript is in development :) please add a validation test of your own to handle this field type:', field);
        }

        // If the field is valid
        if (field.valid) {
          // Hide the error
          field.message.classList.remove('error');
          field.input.parentNode.classList.remove('error');
        } else {
          // Display the error
          field.input.parentNode.classList.add('error');
          if (_this3.settings.message) {
            field.message.innerHTML = _this3.error(field);
            field.message.classList.add('error');
          }

          // Fail the validation
          _this3.validation.valid = false;
        }
      });
      return this.validation.valid;
    }
  }, {
    key: "error",
    value: function error(field) {
      // This will hold our error
      this.validation.error = {};
      // Try grab the name="" of the field, and make it a little nicer to read
      this.validation.error.name = field.input.name.replace(/([A-Z]+)/g, ' $1').replace(/^ /, '');
      // Try grab the field label, if there is one
      this.validation.error.label = field.input.parentNode.parentNode.querySelector('label');
      // This will be the start of our error message
      this.validation.error.message = this.validation.error.label !== null ? this.validation.error.label.innerHTML : name;

      // If it is an input
      if (field.tagName == 'input') {
        // If it is an email
        if (field.type === 'email') {
          // Check it is required
          if (field.required) {
            // Check if it is valid or just required and left blank
            this.validation.error.message += field.value.length ? ' is not valid' : ' is required';
          } else {
            // Tell us it isnt valid
            this.validation.error.message += ' is not valid';
          }
        } else {
          // Tell us it isnt valid
          this.validation.error.message += ' is required';
        }
      } else {
        // Tell us it isnt valid
        this.validation.error.message += ' is required';
      }

      // Return the custom message to the field
      return this.validation.error.message;
    }
  }, {
    key: "submit",
    value: function submit(e) {
      var _this4 = this;
      if (this.recaptcha) {
        if (window.grecaptcha.getResponse() == "") {
          this.recaptcha["default"].classList.add('error');
          window.ScrollControl.scrollTo(offset(this.form.querySelector('.error')).y - 200, 1000);
          e.preventDefault();
          return;
        } else {
          this.recaptcha["default"].classList.remove('error');
        }
      }
      if (this.settings.validate && this.validate() || this.settings.validate == false) {
        var settings = {
          url: this.form.action,
          method: 'POST',
          data: serialize(this.form),
          success: function success(r) {
            _this4.form.reset();
            _this4.settings.success(_this4, r);
          }
        };
        if (!this.form.querySelector('[type="file"]') && !this.form.classList.contains('no-ajax')) {
          e.preventDefault();
          ajax(settings);
          // settings.contentType = 'multipart/form-data';
          // settings.data = new FormData(this.form);
        }

        // console.log(settings);
      } else {
        e.preventDefault();
        window.ScrollControl.scrollTo(offset(this.form.querySelector('.error')).y - 200, 1000);
        console.log('The form is not valid.');
      }
    }
  }]);
  return Form;
}();
export { Form as default };